module.exports = __webpack_public_path__ + "static/media/3 Way Right.57411892.png";